import React from 'react'
import PropTypes from 'prop-types'
import SVG from 'react-inlinesvg'
import { default as SlickSlider } from 'react-slick'

const PrevArrow = ({ className, onClick }) => {
  return (
    <div
      style={{ cursor: 'pointer' }}
      className={ className }
      onClick={ onClick }
    >
      <SVG src="/images/arrow_left.svg" />
    </div>
  )
}

const NextArrow = ({ className, onClick }) => {
  return (
    <div
      style={{ cursor: 'pointer' }}
      className={ className }
      onClick={ onClick }
    >
      <SVG src="/images/arrow_right.svg" />
    </div>
  )
}


const Slider = props => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    customPaging: () => (
      <React.Fragment></React.Fragment>
    ),
    ...props.settings
  };

  return (
    <SlickSlider {...settings}>
      { props.children }
    </SlickSlider>
  )
}

Slider.propTypes = {
  settings: PropTypes.object,
  children: PropTypes.node.isRequired
}

export default Slider